module.exports = __webpack_public_path__ + "static/UnclickTripPostponed-2a84f8567c1a50c679339a8067b18966.png";